import { SAVE_DEVICES_INFO } from '../actions/actionTypes';

const defaultDevices = {
  entities: {
    devices: {},
  },
  result: [],
};

export const devices = (state = defaultDevices, action) => {
  const { type, payload } = action;
  switch (type) {
    case SAVE_DEVICES_INFO:
      return { ...payload.devices };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/devices.js